import GatewayActions from "./gatewayActions";

const initialState = {
  list: null,
  listCounter: 0,
  gateway: null,
};

const gatewayReducer = (state = initialState, action) => {
  switch (action.type) {
    case GatewayActions.LOADED_LIST:
      return {
        ...state,
        list: action.list,
      };
    case GatewayActions.LOADED_GATEWAY:
      return {
        ...state,
        gateway: action.gateway,
      };
    case GatewayActions.CREATED_GATEWAY:
      return {
        ...state,
        listCounter: state.listCounter + 1,
      };
    case GatewayActions.UPDATED_GATEWAY:
      return {
        ...state,
        gateway: action.gateway,
        listCounter: state.listCounter + 1,
      };
    case GatewayActions.DELETED_GATEWAY:
      return {
        ...state,
        listCounter: state.listCounter + 1,
      };
    default:
      return state;
  }
};

export const gatewaySelectors = {
  getList: (state) => state.gateways.list,
  getListCounter: (state) => state.gateways.listCounter,
  getGateway: (state) => state.gateways.gateway,
};

export default gatewayReducer;
